"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBoolean = isBoolean;
exports.isUndefined = isUndefined;
exports.isNull = isNull;
exports.isNumber = isNumber;
exports.isNumeric = isNumeric;
exports.isFunction = isFunction;
exports.isSonarObjectType = isSonarObjectType;
exports.mapWorkflowActionToSonarObjectType = mapWorkflowActionToSonarObjectType;
exports.getSonarObjectTypeApiVersion = getSonarObjectTypeApiVersion;
exports.getSonarObjectTypeId = getSonarObjectTypeId;
exports.getSonarObjectTypeFromId = getSonarObjectTypeFromId;
exports.getSonarObjectTypeSourceLabel = getSonarObjectTypeSourceLabel;
exports.getSonarObjectTypeLabel = getSonarObjectTypeLabel;
exports.getSonarObjectTypeLabelPlural = getSonarObjectTypeLabelPlural;
exports.getSonarObjectTypeAndSourceLabel = getSonarObjectTypeAndSourceLabel;
exports.getSonarObjectTypeAndSourceLabelPlural = getSonarObjectTypeAndSourceLabelPlural;
exports.getSonarObjectTypePeriscopeRoutePart = getSonarObjectTypePeriscopeRoutePart;
exports.isSonarObjectTypeInitiativeFilterAllowed = isSonarObjectTypeInitiativeFilterAllowed;
exports.isSonarObjectTypeSearchAllowed = isSonarObjectTypeSearchAllowed;
exports.isPardotType = isPardotType;
exports.isSonarType = isSonarType;
const sonar_ts_constants_1 = require("@sonar-software/sonar-ts-constants");
const sonar_ts_types_1 = require("@sonar-software/sonar-ts-types");
function isOfCollection(values, value) {
    if (!value || !values.length) {
        return false;
    }
    return values.find((collectionValue) => collectionValue === value) !== undefined;
}
function isBoolean(value) {
    return value === Boolean(value);
}
function isUndefined(value) {
    return value === undefined;
}
function isNull(value) {
    return value === null;
}
function isNumber(value) {
    return typeof value === 'number';
}
function isNumeric(value) {
    return !isNaN(Number(value));
}
// eslint-disable-next-line @typescript-eslint/ban-types
function isFunction(fn) {
    return typeof fn === 'function';
}
function isSonarObjectType(value) {
    return isOfCollection(Object.values(sonar_ts_types_1.SonarObjectType), value);
}
const workflowActionToSonarObjectTypeMap = {
    [sonar_ts_types_1.SfWorkflowActionType.FieldUpdate]: sonar_ts_types_1.SonarObjectType.SalesforceFieldUpdate,
    [sonar_ts_types_1.SfWorkflowActionType.EmailAlert]: sonar_ts_types_1.SonarObjectType.SalesforceWorkflowAlert
};
function mapWorkflowActionToSonarObjectType(type) {
    return workflowActionToSonarObjectTypeMap[type];
}
const sonarObjectTypeMap = {
    [sonar_ts_types_1.SonarObjectType.PardotAutomation]: {
        apiVersion: 'v3',
        id: sonar_ts_types_1.SonarObjectTypeId.PardotAutomation,
        periscopeRoutePart: sonar_ts_types_1.PardotTypeRoutePart.AutomationRule,
        sourceLabel: sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.PARDOT,
        typeLabel: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE.AUTOMATION_RULE,
        typeLabelPlural: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE_PLURAL.AUTOMATION_RULE
    },
    [sonar_ts_types_1.SonarObjectType.PardotEmail]: {
        apiVersion: 'v3',
        id: sonar_ts_types_1.SonarObjectTypeId.PardotEmail,
        periscopeRoutePart: sonar_ts_types_1.PardotTypeRoutePart.Email,
        sourceLabel: sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.PARDOT,
        typeLabel: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE.EMAIL,
        typeLabelPlural: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE_PLURAL.EMAIL
    },
    [sonar_ts_types_1.SonarObjectType.PardotEmailTemplate]: {
        apiVersion: 'v3',
        id: sonar_ts_types_1.SonarObjectTypeId.PardotEmailTemplate,
        periscopeRoutePart: sonar_ts_types_1.PardotTypeRoutePart.EmailTemplate,
        sourceLabel: sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.PARDOT,
        typeLabel: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE.EMAIL_TEMPLATE,
        typeLabelPlural: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE_PLURAL.EMAIL_TEMPLATE
    },
    [sonar_ts_types_1.SonarObjectType.PardotEntity]: {
        apiVersion: 'v3',
        id: sonar_ts_types_1.SonarObjectTypeId.PardotEntity,
        periscopeRoutePart: sonar_ts_types_1.PardotTypeRoutePart.Object,
        sourceLabel: sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.PARDOT,
        typeLabel: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE.OBJECT,
        typeLabelPlural: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE_PLURAL.OBJECT
    },
    [sonar_ts_types_1.SonarObjectType.PardotField]: {
        apiVersion: 'v3',
        id: sonar_ts_types_1.SonarObjectTypeId.PardotField,
        periscopeRoutePart: sonar_ts_types_1.PardotTypeRoutePart.Field,
        sourceLabel: sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.PARDOT,
        typeLabel: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE.FIELD,
        typeLabelPlural: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE_PLURAL.FIELD
    },
    [sonar_ts_types_1.SonarObjectType.PardotForm]: {
        apiVersion: 'v3',
        id: sonar_ts_types_1.SonarObjectTypeId.PardotForm,
        periscopeRoutePart: sonar_ts_types_1.PardotTypeRoutePart.Form,
        sourceLabel: sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.PARDOT,
        typeLabel: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE.FORM,
        typeLabelPlural: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE_PLURAL.FORM
    },
    [sonar_ts_types_1.SonarObjectType.PardotLandingPage]: {
        apiVersion: 'v3',
        id: sonar_ts_types_1.SonarObjectTypeId.PardotLandingPage,
        periscopeRoutePart: sonar_ts_types_1.PardotTypeRoutePart.LandingPage,
        sourceLabel: sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.PARDOT,
        typeLabel: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE.LANDING_PAGE,
        typeLabelPlural: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE_PLURAL.LANDING_PAGE
    },
    [sonar_ts_types_1.SonarObjectType.PardotList]: {
        apiVersion: 'v3',
        id: sonar_ts_types_1.SonarObjectTypeId.PardotList,
        periscopeRoutePart: sonar_ts_types_1.PardotTypeRoutePart.List,
        sourceLabel: sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.PARDOT,
        typeLabel: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE.LIST,
        typeLabelPlural: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE_PLURAL.LIST
    },
    [sonar_ts_types_1.SonarObjectType.PardotPageAction]: {
        apiVersion: 'v3',
        id: sonar_ts_types_1.SonarObjectTypeId.PardotPageAction,
        periscopeRoutePart: sonar_ts_types_1.PardotTypeRoutePart.PageAction,
        sourceLabel: sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.PARDOT,
        typeLabel: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE.PAGE_ACTION,
        typeLabelPlural: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE_PLURAL.PAGE_ACTION
    },
    [sonar_ts_types_1.SonarObjectType.PardotProfile]: {
        apiVersion: 'v3',
        id: sonar_ts_types_1.SonarObjectTypeId.PardotProfile,
        periscopeRoutePart: sonar_ts_types_1.PardotTypeRoutePart.Profile,
        sourceLabel: sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.PARDOT,
        typeLabel: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE.PROFILE,
        typeLabelPlural: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE_PLURAL.PROFILE
    },
    [sonar_ts_types_1.SonarObjectType.SalesforceApexClass]: {
        apiVersion: 'v2',
        id: sonar_ts_types_1.SonarObjectTypeId.SalesforceApexClass,
        periscopeRoutePart: sonar_ts_types_1.SalesforceTypeRoutePart.ApexClass,
        sourceLabel: sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.SALESFORCE,
        typeLabel: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE.APEX_CLASS,
        typeLabelPlural: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE_PLURAL.APEX_CLASS
    },
    [sonar_ts_types_1.SonarObjectType.SalesforceApexTrigger]: {
        apiVersion: 'v2',
        id: sonar_ts_types_1.SonarObjectTypeId.SalesforceApexTrigger,
        periscopeRoutePart: sonar_ts_types_1.SalesforceTypeRoutePart.ApexTrigger,
        sourceLabel: sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.SALESFORCE,
        typeLabel: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE.APEX_TRIGGER,
        typeLabelPlural: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE_PLURAL.APEX_TRIGGER
    },
    [sonar_ts_types_1.SonarObjectType.SalesforceWorkflowAlert]: {
        apiVersion: 'v3',
        id: sonar_ts_types_1.SonarObjectTypeId.SalesforceEmailAlert,
        periscopeRoutePart: sonar_ts_types_1.SalesforceTypeRoutePart.EmailAlert,
        sourceLabel: sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.SALESFORCE,
        typeLabel: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE.EMAIL_ALERT,
        typeLabelPlural: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE_PLURAL.EMAIL_ALERT
    },
    [sonar_ts_types_1.SonarObjectType.SalesforceEmailTemplate]: {
        apiVersion: 'v3',
        id: sonar_ts_types_1.SonarObjectTypeId.SalesforceEmailTemplate,
        periscopeRoutePart: sonar_ts_types_1.SalesforceTypeRoutePart.EmailTemplate,
        sourceLabel: sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.SALESFORCE,
        typeLabel: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE.EMAIL_TEMPLATE,
        typeLabelPlural: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE_PLURAL.EMAIL_TEMPLATE
    },
    [sonar_ts_types_1.SonarObjectType.SalesforceEntity]: {
        apiVersion: 'v3',
        id: sonar_ts_types_1.SonarObjectTypeId.SalesforceEntity,
        periscopeRoutePart: sonar_ts_types_1.SalesforceTypeRoutePart.Entity,
        sourceLabel: sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.SALESFORCE,
        typeLabel: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE.OBJECT,
        typeLabelPlural: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE_PLURAL.OBJECT
    },
    [sonar_ts_types_1.SonarObjectType.SalesforceField]: {
        apiVersion: 'v3',
        id: sonar_ts_types_1.SonarObjectTypeId.SalesforceField,
        periscopeRoutePart: sonar_ts_types_1.SalesforceTypeRoutePart.Field,
        sourceLabel: sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.SALESFORCE,
        typeLabel: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE.FIELD,
        typeLabelPlural: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE_PLURAL.FIELD
    },
    [sonar_ts_types_1.SonarObjectType.SalesforceFieldUpdate]: {
        apiVersion: 'v3',
        id: sonar_ts_types_1.SonarObjectTypeId.SalesforceFieldUpdate,
        periscopeRoutePart: sonar_ts_types_1.SalesforceTypeRoutePart.FieldUpdate,
        sourceLabel: sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.SALESFORCE,
        typeLabel: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE.FIELD_UPDATE,
        typeLabelPlural: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE_PLURAL.FIELD_UPDATE
    },
    [sonar_ts_types_1.SonarObjectType.SalesforceFlow]: {
        apiVersion: 'v3',
        id: sonar_ts_types_1.SonarObjectTypeId.SalesforceFlow,
        periscopeRoutePart: sonar_ts_types_1.SalesforceTypeRoutePart.Flow,
        sourceLabel: sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.SALESFORCE,
        typeLabel: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE.FLOW,
        typeLabelPlural: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE_PLURAL.FLOW
    },
    [sonar_ts_types_1.SonarObjectType.SalesforcePageLayout]: {
        apiVersion: 'v3',
        id: sonar_ts_types_1.SonarObjectTypeId.SalesforcePageLayout,
        periscopeRoutePart: sonar_ts_types_1.SalesforceTypeRoutePart.PageLayout,
        sourceLabel: sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.SALESFORCE,
        typeLabel: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE.PAGE_LAYOUT,
        typeLabelPlural: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE_PLURAL.PAGE_LAYOUT
    },
    [sonar_ts_types_1.SonarObjectType.SalesforcePicklistValue]: {
        apiVersion: 'v2',
        id: sonar_ts_types_1.SonarObjectTypeId.SalesforcePicklistValue,
        periscopeRoutePart: sonar_ts_types_1.SalesforceTypeRoutePart.PicklistValue,
        searchExclude: true,
        sourceLabel: sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.SALESFORCE,
        typeLabel: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE.PICKLIST_VALUE,
        typeLabelPlural: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE_PLURAL.PICKLIST_VALUE
    },
    [sonar_ts_types_1.SonarObjectType.SalesforceProcessBuilder]: {
        apiVersion: 'v3',
        id: sonar_ts_types_1.SonarObjectTypeId.SalesforceProcessBuilder,
        periscopeRoutePart: sonar_ts_types_1.SalesforceTypeRoutePart.ProcessBuilder,
        sourceLabel: sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.SALESFORCE,
        typeLabel: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE.PROCESS_BUILDER,
        typeLabelPlural: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE_PLURAL.PROCESS_BUILDER
    },
    [sonar_ts_types_1.SonarObjectType.SalesforceProfile]: {
        apiVersion: 'v2',
        id: sonar_ts_types_1.SonarObjectTypeId.SalesforceProfile,
        initiativeExclude: true,
        periscopeRoutePart: sonar_ts_types_1.SalesforceTypeRoutePart.Profile,
        searchExclude: true,
        sourceLabel: sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.SALESFORCE,
        typeLabel: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE.PROFILE,
        typeLabelPlural: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE_PLURAL.PROFILE
    },
    [sonar_ts_types_1.SonarObjectType.SalesforceReport]: {
        apiVersion: 'v2',
        id: sonar_ts_types_1.SonarObjectTypeId.SalesforceReport,
        periscopeRoutePart: sonar_ts_types_1.SalesforceTypeRoutePart.Report,
        searchExclude: true,
        sourceLabel: sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.SALESFORCE,
        typeLabel: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE.REPORT,
        typeLabelPlural: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE_PLURAL.REPORT
    },
    [sonar_ts_types_1.SonarObjectType.SalesforceValidationRule]: {
        apiVersion: 'v3',
        id: sonar_ts_types_1.SonarObjectTypeId.SalesforceValidationRule,
        periscopeRoutePart: sonar_ts_types_1.SalesforceTypeRoutePart.ValidationRule,
        sourceLabel: sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.SALESFORCE,
        typeLabel: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE.VALIDATION_RULE,
        typeLabelPlural: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE_PLURAL.VALIDATION_RULE
    },
    [sonar_ts_types_1.SonarObjectType.SalesforceWorkflowRule]: {
        apiVersion: 'v3',
        id: sonar_ts_types_1.SonarObjectTypeId.SalesforceWorkflowRule,
        periscopeRoutePart: sonar_ts_types_1.SalesforceTypeRoutePart.WorkflowRule,
        sourceLabel: sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.SALESFORCE,
        typeLabel: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE.WORKFLOW_RULE,
        typeLabelPlural: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE_PLURAL.WORKFLOW_RULE
    },
    [sonar_ts_types_1.SonarObjectType.SonarTag]: {
        apiVersion: 'v2',
        id: sonar_ts_types_1.SonarObjectTypeId.SonarTag,
        initiativeExclude: true,
        periscopeRoutePart: undefined,
        sourceLabel: sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.SONAR,
        typeLabel: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE.TAG,
        typeLabelPlural: sonar_ts_constants_1.COPY_SONAR_OBJECT_BASE_PLURAL.TAG
    }
};
function getSonarObjectTypeApiVersion(type) {
    var _a;
    return (_a = sonarObjectTypeMap[type]) === null || _a === void 0 ? void 0 : _a.apiVersion;
}
function getSonarObjectTypeId(type) {
    var _a;
    return (_a = sonarObjectTypeMap[type]) === null || _a === void 0 ? void 0 : _a.id;
}
function getSonarObjectTypeFromId(typeId) {
    for (const key in sonarObjectTypeMap) {
        const entry = sonarObjectTypeMap[key];
        if (entry.id === typeId) {
            return key;
        }
    }
    return sonar_ts_types_1.SonarObjectType.SonarTag;
}
function getSonarObjectTypeSourceLabel(type) {
    var _a;
    if (!type) {
        return '';
    }
    return (_a = sonarObjectTypeMap[type]) === null || _a === void 0 ? void 0 : _a.sourceLabel;
}
function getSonarObjectTypeLabel(type) {
    var _a;
    if (!type) {
        return '';
    }
    return (_a = sonarObjectTypeMap[type]) === null || _a === void 0 ? void 0 : _a.typeLabel;
}
function getSonarObjectTypeLabelPlural(type) {
    var _a;
    if (!type) {
        return '';
    }
    return (_a = sonarObjectTypeMap[type]) === null || _a === void 0 ? void 0 : _a.typeLabelPlural;
}
function getSonarObjectTypeAndSourceLabel(type) {
    return `${getSonarObjectTypeSourceLabel(type)} ${getSonarObjectTypeLabel(type)}`;
}
function getSonarObjectTypeAndSourceLabelPlural(type) {
    return `${getSonarObjectTypeSourceLabel(type)} ${getSonarObjectTypeLabelPlural(type)}`;
}
function getSonarObjectTypePeriscopeRoutePart(type) {
    var _a;
    return (_a = sonarObjectTypeMap[type]) === null || _a === void 0 ? void 0 : _a.periscopeRoutePart;
}
function isSonarObjectTypeInitiativeFilterAllowed(type) {
    var _a;
    return !((_a = sonarObjectTypeMap[type]) === null || _a === void 0 ? void 0 : _a.initiativeExclude);
}
function isSonarObjectTypeSearchAllowed(type) {
    var _a;
    return !((_a = sonarObjectTypeMap[type]) === null || _a === void 0 ? void 0 : _a.searchExclude);
}
function isPardotType(type) {
    return getSonarObjectTypeSourceLabel(type) === sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.PARDOT;
}
function isSonarType(type) {
    return getSonarObjectTypeSourceLabel(type) === sonar_ts_constants_1.ORGANIZATION_TYPE_LABELS.SONAR;
}
//# sourceMappingURL=lib.js.map